import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {CreateFilingCommand, CreateThirdPartyFilingCommand} from '../../../commands/dac6-reporter.command';
import {TimeZoneService} from '@core/services/time-zone.service';
import {FileModel} from '@shared/models/file-model';
import {FileManagementService} from '@core/services/file-management.service';
import {FileAttachmentModel} from '../../../models/dac6-repoter.models';
import {SourceTypes} from '../../../Fields';
import {BasketProvider} from '@shared/models/basket-provider';
import {QueryProvider} from '@shared/queries/query-provider';

@Component({
    standalone: false,
    selector: 'particle-create-third-party-filing-dialog',
  templateUrl: './create-third-party-filing-dialog.component.html',
  styleUrls: ['./create-third-party-filing-dialog.component.scss']
})
export class CreateThirdPartyFilingDialogComponent  implements OnInit, OnDestroy, IDialogView {
  data: DialogModel;


  inputForm: FormGroup;
  inputFormErrors: any;
  countries = [];
  private ngUnsubscribe$ = new Subject<void>();
  FileError: any;
  file: any;
  imageResolution: any;
  maxFileSize = null; // in mb
  acceptedTypes = '.xml, .txt, .csv, .xlsx, .pdf, .cht, .doc, .docx, .xls, .jpeg, .jpg, .png';
  legend: any;
  private fileId: string;
  private fileName: string;
  private fileType: string;
  private reportingCountryKey = 'DAC6ReportingCountry';
  private reportingCountries: any;
  private unsubscribe$ = new Subject<void>();
  constructor(private formBuilder: FormBuilder,
              protected particleStore: Store<ParticleState>,
              protected timeZoneService: TimeZoneService,
              private fileManagementService: FileManagementService,
              private queryStore: Store<IQueryState>) {
    this.inputForm = this.formBuilder.group({
      filingCountry  : [''],
      arrangementReferenceId  : [''],
      disclosureReferenceId  : [''],
      dateOfArrangement : ['']
    });
    this.inputFormErrors = {
      filingCountry: {},
      arrangementReferenceId: {},
      disclosureReferenceId: {},
      dateOfArrangement: {}
    };
  }

  ngOnInit() {
    this.data.isDisabledOkButton = true;
    this.inputForm.valueChanges.subscribe(formValue => {
      this.onFormValuesChanged();
    });
    this.data.input['filingSourceType'] = SourceTypes.Dac6ThirdPartyFiling;

    const reportingCountry$ = this.queryStore.pipe(select(getQueryResponse, this.reportingCountryKey));
    reportingCountry$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((dataState: any) => {
      console.log('items', dataState);
      if (dataState) {
        this.countries = dataState.items;
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.reportingCountryKey, {});
  }
  onFormValuesChanged() {
    for (const field in this.inputFormErrors) {
      if (!this.inputFormErrors.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormErrors[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormErrors[field] = control.errors;
      }
    }
    this.validateForm();
  }
  onOkClicked(): boolean {
    let fileAttachmentModel: FileAttachmentModel = new FileAttachmentModel();
    if (this.file) {
      fileAttachmentModel = {
        attachmentId: this.fileId,
        attachmentTitle: this.file.name,
        attachmentType: this.fileType
      };
    }
    const fiingSOurceType = BasketProvider.getBasketMappedSourceType(SourceTypes.Dac6ThirdPartyFiling);
    let filingDate: any;
    if (this.inputForm.value.dateOfArrangement) {
      filingDate = new Date(this.timeZoneService.dateTostringWithoutUTC(this.inputForm.value.dateOfArrangement));
    }
    this.data.input['CreateFilingCommand'] = new CreateThirdPartyFilingCommand(
      fiingSOurceType,
      this.inputForm.value.filingCountry,
      this.inputForm.value.arrangementReferenceId,
      this.inputForm.value.disclosureReferenceId,
      filingDate,
      fileAttachmentModel);
    return true;
  }
  onFileSelect(event) {
    if (event.target.files && event.target.files.length > 0) {// this condition is need for Ie
      this.file = this.getDefaultFile(event.target.files);
      this.validateFile();
      if (!this.FileError) {
        this.uploadFile();
      }
    }
  }
  private validateFile() {
    if (this.file && this.maxFileSize) {
      if (this.file.size > this.maxFileSize * 1024 * 1024) { // file.size is in byte
        this.FileError = `Maximum file size is ${this.maxFileSize}MB`;
      } else {
        this.FileError = null;
      }
    }
  }
  getDefaultFile(files) {
    if (files.length > 0) {
      if (this.FileError) {
        this.FileError = null;
      }
      return files[0];
    }
  }
  removeFile() {
    this.file = null;
    this.FileError = null;
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private uploadFile() {
    this.data.isDisabledOkButton = true;
    const lastIndexofDot = this.file.name.lastIndexOf('.');
    this.fileName = this.file.name.slice(0, lastIndexofDot);
    this.fileType = this.file.name.slice(lastIndexofDot + 1, this.file.name.length);
    const fileModel = FileModel.createClientFileModel('Root/Dac6', this.file, this.fileName);
    this.fileManagementService.uploadFile(this.file, fileModel, true).subscribe((fileId: string) => {
      console.log(fileId);
      this.fileId = fileId;
      this.data.isDisabledOkButton = false;
      this.validateForm();
    });
  }

  private validateForm() {
    this.data.isDisabledOkButton = !this.inputForm.valid || this.FileError;
  }
}
